import axios from 'axios';

const API_URL = '/api/users/';

// Create axios instance with default config
const api = axios.create({
  baseURL: API_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add request interceptor for auth token
api.interceptors.request.use(
  (config) => {
    const user = JSON.parse(localStorage.getItem('user') || 'null');
    if (user?.token) {
      config.headers.Authorization = `Bearer ${user.token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Add response interceptor for consistent error handling
api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error('API Error:', error.response?.data || error.message);
    
    // Handle different error response formats
    let message = 'An unexpected error occurred';
    
    if (error.response?.data) {
      const { data } = error.response;
      
      // Handle new validation error format
      if (data.success === false && data.errors) {
        message = data.errors.map(err => err.message).join(', ');
      }
      // Handle standard error format
      else if (data.message) {
        message = data.message;
      }
      // Handle string error responses
      else if (typeof data === 'string') {
        message = data;
      }
    } else if (error.message) {
      message = error.message;
    }
    
    // Create consistent error object
    const enhancedError = new Error(message);
    enhancedError.response = error.response;
    enhancedError.status = error.response?.status;
    
    return Promise.reject(enhancedError);
  }
);

// Register user
const register = async (userData) => {
  //console.log('authService.register called with:', { ...userData, password: '[REDACTED]' });
  
  const response = await api.post('', userData);
  
  if (response.data?.user) {
    // Store user data from the new response format
    const userToStore = {
      ...response.data.user,
      token: response.data.user.token,
    };
    localStorage.setItem('user', JSON.stringify(userToStore));
    return userToStore;
  }
  
  return response.data;
};

// Resend verification email
const resendVerificationEmail = async (email) => {
  //console.log('authService.resendVerificationEmail called with:', email);
  
  const response = await api.post('resend-verification', { email });
  return response.data;
};

// Verify Email Token
const verifyEmail = async (token) => {
  //console.log('authService.verifyEmail called with token:', token?.substring(0, 8) + '...');
  
  const response = await api.get('verify-email', { params: { token } });
  return response.data;
};

// Log in user
const login = async (userData) => {
//   console.log('authService.login called with:', { 
//     email: userData.email, 
//     password: userData.password ? '[PROVIDED]' : '[MISSING]',
//     passwordLength: userData.password?.length || 0
//   });
  
  const response = await api.post('login', userData);
  
  if (response.data?.user) {
    // Store user data with token
    const userToStore = {
      ...response.data.user,
      token: response.data.user.token,
    };
    localStorage.setItem('user', JSON.stringify(userToStore));
    return userToStore;
  }
  
  return response.data;
};

// Logout User
const logout = () => {
  localStorage.removeItem('user');
  //console.log('User logged out and localStorage cleared');
};

// Newsletter signup
const newsletterSignup = async (email) => {
  //console.log('authService.newsletterSignup called with:', email);
  
  const response = await api.post('/api/users/newsletter', { email });
  return response.data;
};

// Get current user profile
const getProfile = async () => {
  const response = await api.get('me');
  return response.data;
};

// Functions to export
const authService = {
  register,
  logout,
  login,
  newsletterSignup,
  resendVerificationEmail,
  verifyEmail,
  getProfile,
};

export default authService;